module.exports = __webpack_public_path__ + "img/Overview_Single_Frame0001.28953346.png";